import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03aba44d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=03aba44d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aba44d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03aba44d')) {
      api.createRecord('03aba44d', component.options)
    } else {
      api.reload('03aba44d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03aba44d&scoped=true&", function () {
      api.rerender('03aba44d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-renderer/exam/StudentInfo/index.vue"
export default component.exports